import { useEffect } from 'react';
import { connect } from 'redux-bundler-react';

import SitesListFilter from './SitesListFilters';
import SitesListTable from './sites-list-table/SitesListTable';
import Breadcrumb from '@src/app-components/breadcrumb';
import Pagination from '@components/pagination';
import Card from '@src/app-components/card';
import { usePwaMode } from '../data-entry/offline/pwa-mode';
import { getCurrentFieldStudyYear } from '../data-entry/offline/lookup-cache';

import './sitesList.scss';

const breadcrumbLinks = [
  {
    text: 'Sites List',
    current: true,
  },
];

const SitesList = connect(
  'doSitesLoadData',
  'doSetSitesPagination',
  'selectSitesTotalResults',
  ({ doSitesLoadData, doSetSitesPagination, sitesTotalResults }) => {
    const pwaMode = usePwaMode();
    const fieldStudyYear = getCurrentFieldStudyYear();
    const isOnline = navigator.onLine;

    // Load data
    useEffect(() => {
      doSitesLoadData(pwaMode);
    }, []);

    return (
      <div className='container-fluid'>
        <Breadcrumb paths={breadcrumbLinks} />
        {!pwaMode && <SitesListFilter />}
        {pwaMode && (
          <div className='margin-bottom-2'>
            <strong>Field Study Year: {fieldStudyYear}</strong>
          </div>
        )}
        <Card>
          <Card.Header text='Sites List' />
          <Card.Body>
            <SitesListTable />
            {!pwaMode && isOnline && (
              <Pagination
                className='margin-top-2'
                itemCount={sitesTotalResults}
                defaultItemsPerPage={20}
                handlePageChange={(pageNumber, pageSize) => doSetSitesPagination({ pageNumber, pageSize })}
              />
            )}
          </Card.Body>
        </Card>
      </div>
    );
  }
);

export default SitesList;
